module.exports = __webpack_public_path__ + "static/media/cards-icon.5f4164e9.png";